// extracted by mini-css-extract-plugin
export var container = "_uu-0";
export var table = "_uu-2";
export var tableWrapper = "_uu-1";